import { Plane, Vector3 } from "three";
import ExtrudedLoopAnnotationSceneObject from "./ExtrudedLoopAnnotationSceneObject";
import CircleAnnotationData from "../sceneObjectData/CircleAnnotationData";
import { isPlaneEdgeOn } from "../../utils/editHandleVisibility";
import EditHandleData from "../sceneObjectData/EditHandleData";
import EditHandleTypeEnum from "../../enums/EditHandleTypeEnum";
import CommandIdEnum from "../../enums/CommandIdEnums";
import PropertyList from "../properties/PropertyList";
import { PropertyId } from "../properties/PropertyId";
import PropertyItem from "../properties/PropertyItem";
import { PID_CIRCLE_RADIUS } from "../properties/PropertyIds";
import { CATEGORY_DIMENSIONS } from "../properties/PropertyCategoryRegistry";
import lengthCmTranslator from "../properties/translators/lengthCmTranslator";

export default class CircleAnnotationSceneObject extends ExtrudedLoopAnnotationSceneObject<CircleAnnotationData> {

    getProperties(props: PropertyList, filterId?: PropertyId): void {
        super.getProperties(props, filterId);

        const radius = props.getOrCreateProperty(PID_CIRCLE_RADIUS, () => new PropertyItem(PID_CIRCLE_RADIUS, lengthCmTranslator));
        radius.value = this.data.radius;
        radius.categoryId = CATEGORY_DIMENSIONS.id;
    }

    setProperties(props: PropertyList): void {
        super.setProperties(props);

        const radius = props.getProperty<number>(PID_CIRCLE_RADIUS);
        if (radius) this.data.radius = radius.value;

        this.geometry.update(this.data, false);
    }

    getEditHandles(localViewDirection: Vector3): EditHandleData[] {
        const data = this.data;

        // Seen edge-on the circle is just a line, so dragging the radius in-plane is pointless.
        if (isPlaneEdgeOn(localViewDirection, data.placement.axis))
            return super.getEditHandles(localViewDirection);

        // placement.axis is the profile plane's normal (Z); refDirection is the in-plane X axis.
        const plane = new Plane().setFromNormalAndCoplanarPoint(
            data.placement.axis.clone(),
            data.placement.location.clone()
        );
        const radialDir = data.placement.refDirection.clone().normalize();

        return [
            ...super.getEditHandles(localViewDirection),
            new EditHandleData(data.uuid, EditHandleTypeEnum.CIRCLE_RADIUS,
                data.placement.location.clone().add(radialDir.clone().multiplyScalar(data.radius)),
                CommandIdEnum.GeometryMoveEdit,
                (d, delta) => {
                    const circleData = d as CircleAnnotationData;
                    circleData.radius = Math.max(0, circleData.radius + delta.dot(radialDir));
                },
                plane.clone(), radialDir.clone())
        ];
    }
}
